import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { getLineSettings } from '@/features/internal/patient-messaging/apis/lineSettingsApi'

export const useLineSettingsQuery = () => {
  return useQuery({
    queryKey: queryKeys.patientMessaging.lineSettings(),
    queryFn: getLineSettings,
  })
}
